<template>
  <div ref="targetRef" class="lazy-video-wrapper">
    <video
      v-if="isVisible"
      :src="src"
      :class="videoClass"
      :autoplay="autoplay"
      :muted="muted"
      :playsinline="playsinline"
      :controls="controls"
      :controlsList="controlsList || undefined"
      :preload="preload"
      :disablePictureInPicture="disablePictureInPicture"
      @loadstart="$emit('loadstart', $event)"
      @loadeddata="$emit('loadeddata', $event)"
      @canplay="$emit('canplay', $event)"
      @error="$emit('error', $event)"
      @click="$emit('click', src)"
    >
      <source :src="src" type="video/mp4" />
    </video>
    <div
      v-else
      class="absolute inset-0 flex justify-center items-center h-full w-full"
    >
      <slot name="placeholder">
        <div class="w-full h-full bg-gray-800 flex items-center justify-center">
          <UIcon
            name="i-lucide-video"
            class="w-8 h-8 text-gray-600"
          />
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { useLazyLoad } from '@/composables/useLazyLoad'

const props = defineProps({
  src: {
    type: String,
    required: true
  },
  videoClass: {
    type: String,
    default: ''
  },
  autoplay: {
    type: Boolean,
    default: false
  },
  muted: {
    type: Boolean,
    default: true
  },
  playsinline: {
    type: Boolean,
    default: true
  },
  controls: {
    type: Boolean,
    default: false
  },
  controlsList: {
    type: String,
    default: ''
  },
  preload: {
    type: String,
    default: 'metadata'
  },
  disablePictureInPicture: {
    type: Boolean,
    default: false
  },
  rootMargin: {
    type: String,
    default: '100px'
  },
  threshold: {
    type: Number,
    default: 0.01
  }
})

defineEmits(['loadstart', 'loadeddata', 'canplay', 'error', 'click'])

const { targetRef, isVisible } = useLazyLoad({
  rootMargin: props.rootMargin,
  threshold: props.threshold
})
</script>

<style scoped>
.lazy-video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

video[controlslist*="nofullscreen"]::-webkit-media-controls-fullscreen-button {
  display: none;
}
</style>
